export const en = {
    no_domain: "My company don't have a domain",
    no_domain_message: "My company don't have a domain but I want to use your service",
};
